import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

import { useAppDispatch, useAppSelector } from "redux/hooks";
import { selectStep } from "redux/slices/StepSlice";

import { Panel } from "components";
import Wizard from "components/BaseComponents/Wizard";
import { ChangeStep } from "./PaswordFlow/ChangeStep";
import { setClientUID } from "redux/slices/password-slices/PasswordRefreshSlice";

export const getWizardStepTitles = (t: TFunction): string[] => {
  return [
    t("forgot_password_step_personal_informations"),
    t("forgot_password_step_otp"),
    t("forgot_password_step_temporary_password"),
    // t("forgot_password_step_personal_informations"),
    // t("card_password"),
    // t("forgot_password_step_otp"),
    // t("forgot_password_step_temporary_password"),
  ];
};

const PasswordRefresh: FC<{}> = () => {
  const { t } = useTranslation();

  const currentStep = useAppSelector(selectStep);

  const dispatch = useAppDispatch();

  const { clientUID } = useAppSelector((state) => state.PassRefPersonelInfo);

  useEffect(() => {
    if (!clientUID) {
      const rndInt = Math.floor(Math.random() * (9999999999999999 - 0 + 1)) + 0;
      dispatch(setClientUID(rndInt.toString()));
    }
  }, [dispatch, clientUID]);

  return (
    <>
      <Panel width='646px' marginTop='0'>
        <Wizard
          width='872px'
          currentPage={currentStep === 2 ? 3 : currentStep}
          // currentPage={currentStep === 3 ? 4 : currentStep}
          wizardStepTitles={getWizardStepTitles(t)}
        />
        <ChangeStep stepNumber={currentStep} />
      </Panel>
    </>
  );
};

export default PasswordRefresh;
